import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthHeaders = () => {
  const lang = localStorage.getItem("lang") || "en";

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Accept-Language": lang,
  };
};

// Existing invoice APIs
export const getInvoiceList = async (params = {}) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/invoice/list`, {
      params,
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Get Invoice List API Error:", error);
    throw error?.response?.data || { message: "Failed to fetch invoices" };
  }
};

export const getInvoiceDetail = async (id) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/invoice/detail/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Get Invoice Detail API Error:", error);
    throw error?.response?.data || { message: "Failed to fetch invoice detail" };
  }
};

export const printInvoice = async (id) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/invoice/print/${id}`, {
      headers: getAuthHeaders(),
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Print Invoice API Error:", error);
    throw error?.response?.data || { message: "Failed to print invoice" };
  }
};

export const deleteInvoice = async (id) => {
  try {
    const response = await api.delete(`${API_BASE_URL}api/invoice/delete/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Delete Invoice API Error:", error);
    throw error?.response?.data || { message: "Failed to delete invoice" };
  }
};

// New invoice report API
export const getInvoiceReport = async (params = {}) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/invoices/report`, {
      params,
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Get Invoice Report API Error:", error);
    throw error?.response?.data || { message: "Failed to fetch invoice report" };
  }
};

// Customer list for filter dropdown
export const getCustomerOptions = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}api/customer/customer-list`, {
      headers: getAuthHeaders(),
    });

    const customers = response?.data?.data || response?.data || [];

    return customers.map((customer) => ({
      value: customer._id,
      label: `${customer?.firstName?.en || ""} ${customer?.lastName?.en || ""}`.trim() || "N/A",
    }));
  } catch (error) {
    console.error("Get Customer Options API Error:", error);
    return [];
  }
};